import { FC, Dispatch, SetStateAction } from "react";
import TeamData from "./SeaportNxG.json";

interface ITeamData {
  company: string;
  size: string;
  business_classification: string;
  experience: string;
  link: string;
}

interface ISeaportCollapsables {
  team_member: boolean;
  team_experience: boolean;
  quality_assurance: boolean;
}

interface IProps {
  isCollapsed: ISeaportCollapsables;
  setIsCollapsed: Dispatch<SetStateAction<ISeaportCollapsables>>;
}

export const TeamMembers: FC<IProps> = ({ isCollapsed, setIsCollapsed }) => {
  let { teams } = TeamData;
  return (
    <div className="Contract__wrapper__section">
      <h2
        onClick={() =>
          setIsCollapsed({
            ...isCollapsed,
            team_experience: !isCollapsed.team_experience,
          })
        }
        className="collapsable"
      >
        Team Members
        <i
          className={
            isCollapsed.team_experience
              ? "fas fa-caret-down"
              : "fas fa-caret-up"
          }
        ></i>
      </h2>
      <div
        className={`Contract__wrapper__section__content ${
          isCollapsed.team_experience ? "hidden" : ""
        }`}
      >
        <div className="collapse-wrapper">
          <button
            onClick={() =>
              setIsCollapsed({
                ...isCollapsed,
                team_experience: true,
              })
            }
            className="collapse-section"
          >
            Collapse section
          </button>
        </div>
        <div className="nxgTable col-3">
          <div className="nxgTable__header">
            <p>Company</p>
            <p>Size</p>
            <p>Business Classification</p>
          </div>
          {teams.map((team: ITeamData) => {
            return (
              <div className="nxgTable__row">
                <p>{team.company}</p>
                <p>{team.size}</p>
                <p>{team.business_classification}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
